module.exports = __webpack_public_path__ + "static/media/GAMKONORA_ch6_20210921092651_T.9516c0f5.jpg";